var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FundoArgolas",style:(_vm.CoresArgolas)},[_c('div',{staticClass:"anel1"}),_c('div',{staticClass:"anel2"}),_c('div',{staticClass:"anel3"})])}
var staticRenderFns = []

export { render, staticRenderFns }